module.exports = __webpack_public_path__ + "static/media/NetflixLogo.ab665ffa.svg";